export default __webpack_public_path__ + "static/media/fallback-image.76a100ac.png";